import axios from 'axios';

export default class CcsV2 {
  constructor({ baseURL }) {
    this.baseURL = baseURL;
  }

  async initAccount(accountId) {
    const result = await axios.get(`${this.baseURL}/${accountId}/ccs/init`);
    return result.data;
  }

  async isActive(accountId) {
    const { data } = await axios.get(`${this.baseURL}/${accountId}/ccs/verify`);
    return data;
  }

  async searchPolicy(accountId, {
    name, noOfRecordsPerPage, pageNumber, fetchPaginationMetadata = true,
  }) {
    const { data } = await axios.post(`${this.baseURL}/${accountId}/ccs/policies/search`, {
      name, noOfRecordsPerPage, pageNumber, calcPaginationMetaData: fetchPaginationMetadata,
    });
    return data;
  }

  async createPolicy(accountId, policy) {
    const { data } = await axios.post(`${this.baseURL}/${accountId}/ccs/policies/create`, policy);
    return data;
  }

  async updatePolicy(accountId, policy) {
    const { data } = await axios.post(`${this.baseURL}/${accountId}/ccs/policies/update`, policy);
    return data;
  }

  async reorderPolicy(accountId, policy, policyOrder, direction) {
    const { data } = await axios.post(`${this.baseURL}/${accountId}/ccs/policies/reorder`, { policy, policyOrder, direction });
    return data;
  }

  async deletePolicy(accountId, docId) {
    const { data } = await axios.delete(`${this.baseURL}/${accountId}/ccs/policies/${docId}`);
    return data;
  }

  async getUserIntegrationToken(accountId) {
    const { data } = await axios.get(`${this.baseURL}/${accountId}/ccs/userintegration/token`);
    return data;
  }

  async getMasterUserToken(accountId) {
    const { data } = await axios.get(`${this.baseURL}/${accountId}/ccs/token`);
    return data;
  }

  async initUserIntegrationAccount(accountId) {
    const result = await axios.post(`${this.baseURL}/${accountId}/ccs/userintegration/init`);
    return result.data;
  }

  async recycleUserIntegrationAccount(accountId, username) {
    const result = await axios.post(`${this.baseURL}/${accountId}/ccs/userintegration/recycle`, { username });
    return result.data;
  }

  async getUserIntegrationUsername(accountId) {
    const result = await axios.get(`${this.baseURL}/${accountId}/ccs/userintegration/username`);
    return result.data;
  }

  async getUserIntegrationPassword(accountId) {
    const result = await axios.get(`${this.baseURL}/${accountId}/ccs/userintegration/password`);
    return result.data;
  }

  async getUserIntegrationCredentials(accountId) {
    const result = await axios.get(`${this.baseURL}/${accountId}/ccs/userintegration/credentials`);
    return result.data;
  }

  async getSystemContext(brandId, type) {
    const { data } = await axios.get(`${this.baseURL}/${brandId}/${type}/context`);
    return data;
  }

  async getSdeList(brandId) {
    const { data } = await axios.get(`${this.baseURL}/${brandId}/sde/variables/list`);
    return data;
  }

  async getCustomContexts(brandId) {
    const { data } = await axios.get(`${this.baseURL}/${brandId}/custom`);
    return data;
  }

  async createCustomContext(type, brandId, varName, payload) {
    const { data } = await axios.post(`${this.baseURL}/${brandId}/custom/${varName}`, { payload, type });
    return data;
  }

  async getCustomAttribute(brandId, varName) {
    const { data } = await axios.get(`${this.baseURL}/${brandId}/custom/${varName}`);
    return data;
  }

  async deleteCustomContext(brandId, varName) {
    const { data } = await axios.delete(`${this.baseURL}/${brandId}/custom/${varName}`);
    return data;
  }

  async getPolicyHistory(accountId, body) {
    const result = await axios.post(`${this.baseURL}/${accountId}/ccs/policy/history`, body);
    return result.data;
  }

  async normalizePriorities(accountId) {
    const result = await axios.post(`${this.baseURL}/${accountId}/ccs/policy/normalize`);
    return result.data;
  }

  async getPolicies(accountId) {
    const result = await axios.get(`${this.baseURL}/${accountId}/ccs/policy/list`);
    return result.data;
  }

  async createMisToken(accountId) {
    return await axios.post(`${this.baseURL}/${accountId}/mistoken/create`);
  }
}
